import { render, staticRenderFns } from "./questionItem.vue?vue&type=template&id=2ba1084d&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"
import style0 from "./questionItem.vue?vue&type=style&index=0&id=2ba1084d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1084d",
  null
  
)

export default component.exports